import axios, { AxiosResponse } from 'axios'
import { IBehavior } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchLastUpdateBehaviorsTracking = async (patientId: number): Promise<IBehavior[]> => {
  const response = await axios.get(`${hstoryAPI}/patients/${patientId}/behavioral-measurements?lastUpdate`)
  const { data }: AxiosResponse<IBehavior[]> = response
  return data
}

export const fetchActivitiesHistory = async (patientId: number): Promise<IBehavior[]> => {
  const response = await axios.get(`${hstoryAPI}/patients/${patientId}/behavioral-measurements?type=Exercício`)
  const { data }: AxiosResponse<IBehavior[]> = response
  return data
}
